import { render, staticRenderFns } from "./DeceasedInfo.vue?vue&type=template&id=19119738&scoped=true"
import script from "./DeceasedInfo.vue?vue&type=script&lang=js"
export * from "./DeceasedInfo.vue?vue&type=script&lang=js"
import style0 from "./DeceasedInfo.vue?vue&type=style&index=0&id=19119738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19119738",
  null
  
)

export default component.exports